import { IApiConfig } from "../Contracts/IApiConfig";

const hostname = window && window.location && window.location.hostname;
const app_Root = {} as IApiConfig;

if (hostname.indexOf("localhost") > -1) {
  app_Root.reportingHost = "https://repapi.inn-flow.net/api";
  // app_Root.reportingHost = "https://tsrepapi.inn-flow.net/api";
  app_Root.backendHost = "https://apiv2.inn-flow.net/api";
  app_Root.notificationHubURL = "https://apiv2.inn-flow.net/hubs";
  app_Root.dwollaConfigure = "production";
  
  app_Root.microsoftLoginTenantId = "7f484ab1-91b8-49ee-85b9-fddd578cffbc";
  app_Root.microsoftLoginClientId = "0c96ad99-e084-43cc-8613-d7c1715ec5a6";
  app_Root.microsoftredirectUri ="https://inn-flow.net/mgtportal"


} else {
  app_Root.environment = "production";
  app_Root.reportingHost = "https://repapi.inn-flow.net/api";
  // app_Root.reportingHost = "https://tsrepapi.inn-flow.net/api";
  app_Root.backendHost = "https://apiv2.inn-flow.net/api";
  app_Root.notificationHubURL = "https://apiv2.inn-flow.net/hubs";
  app_Root.dwollaConfigure = "production";

  app_Root.microsoftLoginTenantId = "7f484ab1-91b8-49ee-85b9-fddd578cffbc";
  app_Root.microsoftLoginClientId = "0c96ad99-e084-43cc-8613-d7c1715ec5a6";
  app_Root.microsoftredirectUri ="https://inn-flow.net/mgtportal"
}

export const API_ROOT = app_Root;
